/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M6 0v1h8V0h2v1h2a2 2 0 012 2v15a2 2 0 01-2 2H2a2 2 0 01-2-2V3a2 2 0 012-2h2V0h2zm12 8H2v10h16V8zM4 3H2v3h16V3h-2v1h-2V3H6v1H4V3z" _fill="#005BA5" fill-rule="evenodd"/>'
  }
})
